module.exports = __webpack_public_path__ + "img/5.98aba05b.jpg";